import {Main,Lesson,Course,Join,Contact,Recruiting,Blog,Navber,Footer,Policy} from './index';
import 'tailwindcss/tailwind.css';
import { Routes, Route } from 'react-router-dom';

const App: React.VFC = () => {
   // URL 宣言
   const url ='/STEMON/';
  return (
    <div >
      <Navber />
      
      <Routes>
        <Route path={url} element={<Main />} />
        <Route path={url + 'Lesson'} element={<Lesson />} />
        <Route path={url + 'Course'} element={<Course />} />
        <Route path={url + 'Join'} element={<Join />} />
        <Route path={url + 'Contact'} element={<Contact />} />
        <Route path={url + 'Recruiting'} element={<Recruiting />} />
        <Route path={url + 'Blog'} element={<Blog />} />
        <Route path={url + 'Policy'} element={<Policy />} />
      </Routes>
      <Footer />
    </div>
  );
}
export default App;
